import { QueryHookOptions, useQuery } from '@apollo/client';
import getOemSegments from './managedOemSegmentsQuery.graphql';

export const useManagedOemSegmentsQuery = (
  options?: QueryHookOptions<
    ManagedOemSegmentsQuery,
    ManagedOemSegmentsQueryVariables
  >,
) => {
  return useQuery<ManagedOemSegmentsQuery, ManagedOemSegmentsQueryVariables>(
    getOemSegments,
    { errorPolicy: 'all', ...options },
  );
};
